import { render, staticRenderFns } from "./AlertInformation.vue?vue&type=template&id=234f2ffe&scoped=true&"
import script from "./AlertInformation.vue?vue&type=script&lang=js&"
export * from "./AlertInformation.vue?vue&type=script&lang=js&"
import style0 from "./AlertInformation.vue?vue&type=style&index=0&id=234f2ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f2ffe",
  null
  
)

export default component.exports